import { Global } from '@emotion/react';
import type { IntrinsicSystemProps } from '@hover/blueprint';
import { Box, NextProvider, system, transition } from '@hover/blueprint';
import React from 'react';

import { UploadImage } from 'src/modules/homeownerApp/components/UploadImage';
import { useCurrentPage } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

import { useHomeownerAppContext } from '../../hooks/useHomeownerAppContext';
import { HomeownerAppProvider } from '../../providers/HomeownerAppProvider';
import { SheetMenu } from '../SheetMenu';
import { Toolbar } from '../toolbar';

export interface LayoutContainerProps extends IntrinsicSystemProps<'div'> {}

const toolbarExclusionRoutes = [
  Route.HOMEOWNER_APP_ORIGINAL.page,
  Route.HOMEOWNER_APP_SHARE.page,
];

const LayoutContainer = ({ children, ...props }: LayoutContainerProps) => {
  const page = useCurrentPage();

  const showToolbar = !toolbarExclusionRoutes.includes(page ?? undefined);
  const isHome = page === Route.HOMEOWNER_APP_HOME.page;

  const { toolbarTabletBackground } = useHomeownerAppContext();

  return (
    <system.div {...props}>
      <Global
        styles={{
          body: {
            background: isHome ? toolbarTabletBackground : 'neutral.0',
            ...transition.easing500('background'),
          },
        }}
      />
      {showToolbar && <Toolbar background="transparent" />}
      <Box display="block">{children}</Box>
      <UploadImage />
      <SheetMenu />
    </system.div>
  );
};

export interface LayoutProps extends LayoutContainerProps {}

const Layout = (props: LayoutContainerProps) => (
  <HomeownerAppProvider>
    <NextProvider attach>
      <LayoutContainer {...props} />
    </NextProvider>
  </HomeownerAppProvider>
);

export { Layout };
